import { Component, OnInit, OnChanges, SimpleChanges, Input } from '@angular/core';
import { GlobalSearchService } from '../../../services/globalsearchservice.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
@Component({
	selector: 'app-iframe-view',
	templateUrl: './iframe-view.component.html',
	styleUrls: ['./iframe-view.component.scss']
})
export class IframeViewComponent implements OnInit, OnChanges {
	@Input() src: any = '';
	@Input() type: any = false;
	link: SafeResourceUrl;
	config: any [];
	color: any = 'blue';
	token: any = false;
	constructor(private sanitizer: DomSanitizer, private globalSearchService: GlobalSearchService) {
		this.color = this.globalSearchService.getColor();
	}

	ngOnInit(): void {
		this.updateLink();
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.src || changes.type) {
			this.updateLink();
		}
	}

	private updateLink(): void {
		const raw = typeof this.src === 'string' ? this.src : '';
		if (!this.type) {
			this.link = this.sanitizer.bypassSecurityTrustResourceUrl(
				raw + (raw.indexOf('?') === -1 ? '?' : '&') + 'header=false&template_color=' + this.color
			);
		} else {
			this.link = this.sanitizer.bypassSecurityTrustResourceUrl(raw);
		}
	}


}
